export const TWINKLE_STARS = [
  { top: '8%', left: '12%', size: 4, color: '#FDE68A', duration: '2.8s', delay: '.2s' },
  { top: '15%', left: '28%', size: 2, color: '#FBBF24', duration: '3.5s', delay: '.7s' },
  { top: '6%', left: '55%', size: 6, color: '#FDE68A', duration: '2.2s', delay: '1.2s' },
  { top: '20%', left: '72%', size: 4, color: '#FCD34D', duration: '4s', delay: '.4s' },
  { top: '35%', left: '5%', size: 2, color: '#FDE68A', duration: '3.1s', delay: '.9s' },
  { top: '65%', left: '20%', size: 4, color: '#FBBF24', duration: '2.6s', delay: '1.5s' },
  { top: '75%', left: '80%', size: 2, color: '#FDE68A', duration: '3.8s', delay: '.3s' },
  { top: '88%', left: '40%', size: 6, color: '#FCD34D', duration: '2.4s', delay: '1.8s' },
  { top: '50%', left: '90%', size: 4, color: '#FDE68A', duration: '3.3s', delay: '.6s' },
]

export const FEATURE_PILLS = [
  { icon: '✓', iconColor: '#22c55e', label: 'Live Classes' },
  { icon: 'star', label: 'Certified Courses' },
  { icon: '📚', label: '12+ Courses' },
  { icon: '👨‍🏫', label: 'Expert Teachers' },
]

export const STUDENT_AVATARS = [
  { letter: 'R', gradient: 'linear-gradient(135deg,#D97706,#92400E)' },
  { letter: 'S', gradient: 'linear-gradient(135deg,#B45309,#7C2D12)' },
  { letter: 'A', gradient: 'linear-gradient(135deg,#92400E,#451A03)' },
]

export const ORBIT_ANGLES_12 = Array.from({ length: 12 }, (_, i) => i * 30)
export const CARDINAL_DOTS_8 = Array.from({ length: 8 }, (_, i) => i * 45)
